// Phase 18 Plan 04 Task 1 — POLISH-07 global aria-live regions.
//
// Two regions are mounted at page load (NOT lazy) so screen readers compile
// the tracker on initial accessibility-tree build (RESEARCH §Pitfall 3).
//
// Fixed mode per region — toggling aria-live at runtime is unreliable across
// NVDA/VoiceOver/JAWS (RESEARCH §Pitfall 3 + Anti-Patterns).
//
// Mounted by RootApp (apps/web/src/game/RootApp.tsx) as a sibling of <SkipLink>
// and <Router> so the regions exist before any route renders.

import type { JSX } from 'react'

export function LiveRegion(): JSX.Element {
  return (
    <>
      <div
        id="rg-live-polite"
        className="sr-only"
        aria-live="polite"
        aria-atomic="true"
      />
      <div
        id="rg-live-assertive"
        className="sr-only"
        aria-live="assertive"
        aria-atomic="true"
      />
    </>
  )
}
